var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TR",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#E92434",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "18.6857803 10.8124704 17.1183529 11.929849 17.6966815 10.093848 16.1496296 8.94842503 18.0744836 8.93109264 18.6857803 7.10580368 19.297077 8.93109264 21.221931 8.94842503 19.6748791 10.093848 20.2532076 11.929849 18.6857803 10.8124704 18.6857803 10.8124704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666667,4 C14.5916482,4 16.3049005,4.90652059 17.4028092,6.31594735 C16.5556241,5.70014277 15.4903749,5.33333333 14.3333333,5.33333333 C11.5719096,5.33333333 9.33333333,7.42267117 9.33333333,10 C9.33333333,12.5773288 11.5719096,14.6666667 14.3333333,14.6666667 C15.4903749,14.6666667 16.5556241,14.2998572 17.4028701,13.6840351 C16.3049005,15.0934794 14.5916482,16 12.6666667,16 C9.35295817,16 6.66666667,13.3137085 6.66666667,10 C6.66666667,6.6862915 9.35295817,4 12.6666667,4 Z",
    id: "Oval-41",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr);
export default __webpack_public_path__ + "static/media/TR.7dbc8337a8e4e57390e746a1312fc783.svg";
export { ForwardRef as ReactComponent };